/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    UnspentNonMotoringConvictionsLabel: {
        id: 'spm.components.claimsAndConvictions.UnspentNonMotoringConvictionsLabel',
        defaultMessage: 'Do {pronoun} have any unspent non-motoring convictions?'
    },
    UnspentNonMotoringConvictionsSubLabel: {
        id: 'spm.components.claimsAndConvictions.UnspentNonMotoringConvictionsSubLabel',
        defaultMessage: 'If {pronoun} are unsure whether {possessivePronoun} non-motoring conviction is spent, or if it should be disclosed, please visit {link}.'
    }
});
